import React, { useEffect, useRef } from 'react';
import css from './overrideFormStyle.css?raw';

declare global {
	interface Window {
		d365mkt?: unknown;
	}
}

type ScriptProps = {
	html: string;
	formLoaderScriptUrl?: string;
	inverse?: boolean;
};

export const Script: React.FunctionComponent<ScriptProps> = ({
	html,
	formLoaderScriptUrl,
	inverse,
}): React.JSX.Element => {
	const htmlRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!htmlRef.current || !formLoaderScriptUrl) return;

		// delete d365mkt from the scripts or else the form will not reload
		if (window?.d365mkt) delete window.d365mkt;

		setTimeout(() => {
			const s = document.createElement('script');
			s.type = 'text/javascript';
			s.src = formLoaderScriptUrl;
			s.async = true;

			htmlRef.current?.appendChild(s);
		}, 100);
	}, [formLoaderScriptUrl]);

	// is html a emptystring
	if (!html) return <div></div>;

	return (
		<>
			<style>{css}</style>
			<div
				className={`ccj-form ${inverse ? 'ccj-form-inverse' : ''}`}
				ref={htmlRef}
				dangerouslySetInnerHTML={{ __html: html }}
			/>
		</>
	);
};
